import Vue from 'vue'
import Vuex from 'vuex'

import clients from './modules/clients'
import birthdays from './modules/birthdays'
import anniversaries from './modules/anniversaries'

Vue.use(Vuex)

const state = {
    loading: true
}

const getters = {
    loading: state => state.loading,
}

const mutations = {
    setLoading(state, loading) {
        state.loading = loading
    },
}

const actions = {
    updateLoading: ({ commit }, loading) => commit('setLoading', loading),
}

export default new Vuex.Store({
    namespaced: true,
    state,
    getters,
    mutations,
    actions,
    modules: {
        anniversaries,
        birthdays,
        clients
    }
})
